import React, { useState, useEffect } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Alert, TextField, List, ListItem, ListItemText } from '@mui/material';
import ApiRequestService from '../../component/ApiRequestService';
import { BeatLoader } from 'react-spinners';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell
} from '@mui/material';

const QBDeleteDialog = ({ showDialog, data, handleClose, handleDelete }) => {

    const [type, setType] = useState("");
    const [name, setName] = useState("");
    const [loading, setLoading] = useState(false);
    const [quizArr, setQuizArr] = useState([]);
    const [confirmText, setConfirmText] = useState("");

    useEffect(() => {
        if (showDialog && data) {
            setConfirmText("");
            setType(data.deleteType);
            if (data.deleteType === "SubCategory") {
                setName(data.subcategory_name);
            } else if (data.deleteType === "Category") {
                setName(data.category_name);
            } else if (data.deleteType === "Topic") {
                setName(data.topic_name);
            } else if (data.deleteType === "Subject") {
                setName(data.subject_name);
            }
            checkIfUsedInQuizes();
        } else {
            setType("");
            setName("");
            setConfirmText("");
            setQuizArr([]);
        }
    }, [data])

    const checkIfUsedInQuizes = () => {
        setLoading(true);
        ApiRequestService({
            url: '/checkIfQBIsUsed',
            method: 'POST',
            data: data,
        }).then(res => {
            if (res && res.data && res.data.data) {
                setQuizArr(res.data.data);
            } else {
                setQuizArr([]);
            }
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <Dialog onClose={(_, reason) => {
            if (reason !== 'backdropClick') {
                handleClose();
            }
        }} open={showDialog}
            maxWidth='sm'
            fullWidth
            disableEscapeKeyDown

        >
            <DialogTitle>Delete {type}?</DialogTitle>

            {loading ? <center className='mb-5'>
                <BeatLoader color={'#bb0000'} loading={true} size={15} />
            </center>
                :
                <React.Fragment>
                    <DialogContent>
                        {quizArr && quizArr.length ?
                            <div className='mb-4'>
                                <Alert severity="warning" style={{
                                    fontSize: '1rem'
                                }}>
                                    <div className='mb-2'>
                                        You cannot delete this {type} because it is used in the following quizzes:
                                    </div>

                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Quiz ID</TableCell>
                                                <TableCell>Quiz Name</TableCell>
                                                <TableCell>University</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {quizArr.map((quiz, index) => {
                                                let university = quiz.university;
                                                if (university === '') { // current university
                                                    const universityArr = window.location.hostname.split(".");
                                                    if (universityArr && universityArr.length > 0) {
                                                        university = universityArr[0];
                                                    }
                                                }

                                                return (
                                                    <TableRow key={index}>
                                                        <TableCell>{quiz.quiz_id}</TableCell>
                                                        <TableCell>{quiz.quiz_name}</TableCell>
                                                        <TableCell>{university}</TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>

                                    {/* <List dense>
                                        {quizArr.map((quiz, index) => {
                                            let university = quiz.university;
                                            if (university === '') { // current university
                                                let universityArr = window.location.hostname.split(".");
                                                if (universityArr && universityArr.length > 0) {
                                                    university = universityArr[0];
                                                }
                                            }
                                            return (
                                                <ListItem key={index} disableGutters>
                                                    <ListItemText
                                                        primary={`Quiz ID: ${quiz.quiz_id} | Quiz Name: ${quiz.quiz_name} | University: ${university}`}
                                                    />
                                                </ListItem>
                                            )
                                        })}
                                    </List> */}

                                    <div className='mt-4'>Please remove them manually from these quizzes before attempting to delete it.</div>
                                </Alert>
                            </div>
                            : null}
                        {quizArr && quizArr.length <= 0 ?
                            <React.Fragment>
                                <div>Are you sure you want to delete this <strong>{name}</strong> {type} ?</div>
                                <TextField size='small' style={{ width: '100%' }} className='mt-2' placeholder='Type "Confirm"' onChange={e => setConfirmText(e.target.value)} />
                            </React.Fragment>
                            : null}

                    </DialogContent>

                    <DialogActions>
                        <Button variant='outlined' onClick={handleClose}>Cancel</Button>
                        {quizArr && quizArr.length <= 0 ?
                            <Button variant='contained'
                                disabled={confirmText !== "Confirm"}
                                onClick={handleDelete}
                            >Delete</Button>
                            : null}
                    </DialogActions>

                </React.Fragment>
            }
        </Dialog >
    )
}

export default QBDeleteDialog;
